module.exports = __webpack_public_path__ + "img/investment_desktop.97129c17.svg";